// extracted by mini-css-extract-plugin
export default {"wrapperPlayButton":"PlayButton_wrapperPlayButton__Ntb8J"};